import styled from 'styled-components';

import { OptimisticPublicationDate } from '@xing-com/crate-jobs-components-optimistic-publication-date';

type Props = {
  date?: string;
};

const StyledPublicationDate = styled(OptimisticPublicationDate)`
  white-space: nowrap;
`;

export const PublishedDate: React.FC<Props> = ({ date }) => {
  if (!date) return null;
  return (
    <StyledPublicationDate
      noMargin
      data-testid="job-details-published-date"
      date={date}
    />
  );
};
